import { getEnv } from '@luna/env';

import { clientOptionsFactory } from './payments/clientOptions';

clientOptionsFactory.set(() => ({ baseUrl: `${getEnv().apiGatewayUrl}payment` }));
